export default ['updateSidebar', 'setReferrer'].reduce((acc, value) => {
  acc[value] = value
  return acc
}, {})
